if (!customElements.get('mm-whatsapp')) {
  customElements.define('mm-whatsapp', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.panel = this.querySelector('.mm-wa__panel');
      this.launcher = this.querySelector('[data-mm-wa-toggle]');
      this.querySelector('[data-mm-wa-close]').addEventListener('click', () => { this.setOpen(false); this.remember(); this.launcher.focus(); }, { signal });
      this.launcher.addEventListener('click', () => { this.setOpen(this.panel.hidden); this.remember(); }, { signal });
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && !this.panel.hidden) { this.setOpen(false); this.remember(); this.launcher.focus(); } }, { signal });
      let shown = false;
      try { shown = sessionStorage.getItem('mm-whatsapp-seen') === '1'; } catch (_) {}
      if (this.dataset.autoOpen === 'true' && !shown && this.dataset.designMode !== 'true') {
        this.timer = setTimeout(() => {
          if (!document.querySelector('dialog[open], .mm-g.is-open, .mm-fin.is-open')) { this.setOpen(true); this.remember(); }
        }, Math.max(0, Number(this.dataset.delay) || 0) * 1000);
      }
    }
    setOpen(open) {
      this.panel.hidden = !open;
      this.launcher.setAttribute('aria-expanded', String(open));
    }
    remember() { try { sessionStorage.setItem('mm-whatsapp-seen', '1'); } catch (_) {} }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
  });
}
